export default {
  name: "TaxAdvantageSection",

  data() {
    return ({
      tax_data: {
        badge_value: "100%",
        badge_label: "Tax Deductible",
        kicker: "Smart Philanthropy",
        title: "The Tax Advantage",
        description:
          "Your capital is administered via a registered Public Benefit Organisation. Full Section 18A tax deductibility ensures your grant acts as first-loss capital that de-risks the ecosystem for investors, while you receive a fully deductible contribution receipt.",
      },
    });
  },
};
